import { allPass, anyPass, complement, equals, isEmpty, isNil } from 'ramda';
import { ExternalSource, MainSource, OtherSource, Source, SupportedSourcesList } from '../../constants/Source';
import { contained } from 'ramda-adjunct';

type TIsSource = (source: Source) => boolean;

export const isSourceSupported = allPass([complement(isNil), complement(isEmpty), contained(SupportedSourcesList)]);

export const isAllSource: TIsSource = equals(MainSource.All);

export const isTrash: TIsSource = equals(MainSource.Trash);

export const isSiteFiles: TIsSource = equals(MainSource.SiteFiles);

export const isVisitorsUploads: TIsSource = equals(MainSource.VisitorsUploads);

export const isFavorites: TIsSource = equals(MainSource.Favorites);

export const isMediaFromWix: TIsSource = equals(MainSource.MediaFromWix);
export const isNTT: TIsSource = equals(MainSource.NTT);
export const isYell: TIsSource = equals(MainSource.Yell);
export const isEnterprise: TIsSource = equals(MainSource.Enterprise);

export const isShutterstockPicture: TIsSource = equals(MainSource.Shutterstock);
export const isShutterstockVideo: TIsSource = equals(MainSource.ShutterstockVideo);
export const isShutterstock: TIsSource = anyPass([isShutterstockPicture, isShutterstockVideo]);

export const isRecommended: TIsSource = equals(MainSource.Recommended);

export const isWixSite: TIsSource = anyPass([equals(ExternalSource.WixSite), equals(ExternalSource.Wixel)]);
export const isGooglePhotos: TIsSource = equals(ExternalSource.GooglePhotos);
export const isInstagram: TIsSource = equals(ExternalSource.Instagram);

export const isExternal: TIsSource = equals(OtherSource.External);

export const isHome: TIsSource = equals(MainSource.Home);

export const isBoards: TIsSource = equals(MainSource.Boards);

export const isUnsplash: TIsSource = equals(MainSource.Unsplash);
